import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SocialOneDriveIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialOneDrive",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M13.332 21.96c.423-.83.775-1.664 1.155-2.513l.637-1.424c.388-.786.816-1.526 1.29-2.265.882-1.37 1.963-2.658 3.3-3.596 1.82-1.285 3.946-1.757 6.197-1.464a10.74 10.74 0 0 0-4.275-4.1 10.62 10.62 0 0 0-8.238-.723c-1.555.506-2.944 1.39-4.11 2.531a9.7 9.7 0 0 0-1.418 1.782 47 47 0 0 0-1.517 2.57l-2.286 4.187-.9 1.599A2.4 2.4 0 0 1 .209 19.63a8.95 8.95 0 0 0 8.313 6.966c.48-.042.936-.197 1.37-.43 1.541-.853 2.651-2.656 3.44-4.206M2.014 17.878l1.448-2.62 1.882-3.425 1.427-2.408.439-.65C3.418 9.497.591 12.687.076 16.461c-.05.364-.101.697-.062 1.05.06.54.478.924 1.015.938.425.011.773-.19.985-.572m9.6 8.717c-.017-.01.012.01.045.031l13.138.014a7.1 7.1 0 0 0 3.562-.985 7.375 7.375 0 0 0 3.55-7.51 7.39 7.39 0 0 0-5.302-5.935 7.3 7.3 0 0 0-4.197.09c-1.856.602-3.306 1.967-4.424 3.528a20 20 0 0 0-1.708 2.875l-.715 1.624c-.402.912-.795 1.801-1.267 2.68-.707 1.32-1.54 2.587-2.681 3.588"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.332 21.96c-.789 1.55-1.899 3.353-3.44 4.207-.434.232-.89.387-1.37.429A8.95 8.95 0 0 1 .209 19.63a2.4 2.4 0 0 0 2.958-1.086l.9-1.599 2.286-4.186c.481-.88.982-1.724 1.517-2.57.41-.652.868-1.245 1.418-1.783 1.166-1.14 2.555-2.025 4.11-2.531a10.62 10.62 0 0 1 8.238.723 10.74 10.74 0 0 1 4.275 4.1c-2.251-.293-4.377.18-6.197 1.464-1.337.938-2.418 2.227-3.3 3.596a23 23 0 0 0-1.29 2.265l-.637 1.424c-.38.849-.732 1.683-1.155 2.513"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.615 26.595c1.14-1.001 1.974-2.268 2.681-3.587.472-.88.865-1.769 1.267-2.68l.715-1.625a20 20 0 0 1 1.708-2.875c1.118-1.561 2.568-2.926 4.424-3.528a7.3 7.3 0 0 1 4.197-.09 7.39 7.39 0 0 1 5.301 5.935 7.375 7.375 0 0 1-3.549 7.51 7.1 7.1 0 0 1-3.562.985l-13.138-.014c-.033-.021-.062-.041-.044-.03M2.014 17.878c-.212.382-.56.583-.985.572a1.03 1.03 0 0 1-1.015-.938c-.04-.353.012-.686.062-1.05.515-3.774 3.342-6.964 7.134-7.688l-.44.65-1.426 2.41-1.882 3.425z"
    })]
  }));
};
SocialOneDriveIcon.displayName = 'SocialOneDriveIcon';